export default __webpack_public_path__ + "static/media/Cafe-Beaujolais.466a6fa3.jpg";